import { IUSER_NOTIFICATION_TYPES } from 'components/NotificationPanel/types'
import { ROLES } from 'config'
import { createSelector } from 'reselect'

import { getRoleFromPath } from 'utils/helper'
export const getNotifications = (state) => state.user?.notifications?.data
export const getTenantId = (state) => state.user.tenantId

export const getParsedNotificationSelector = createSelector(
  [getNotifications, getTenantId],
  (notifications, tenantId) => {
    const userRole = getRoleFromPath()
    const isAdvisor = userRole === ROLES.BSO_ADMIN || userRole === ROLES.BSO_ADVISOR
    return notifications?.map((notification) => {
      const parsedMeta = JSON.parse(notification?.meta)
      if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.MONTHLY_ATTESTATION_TIME &&
        userRole === ROLES.BUSINESS_OWNER
      ) {
        return {
          ...notification,
          meta: parsedMeta,
          url: `${userRole}/${tenantId}/attestation`,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.MONTHLY_ATTESTATION_UPDATE &&
        (userRole === ROLES.BSO_ADMIN || userRole === ROLES.BSO_ADVISOR)
      ) {
        return {
          ...notification,
          meta: parsedMeta,
          url: `${userRole}/${tenantId}/data-reports/reports`,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.MONTHLY_ATTESTATION_TIME &&
        (userRole === ROLES.BSO_ADMIN || userRole === ROLES.BSO_ADVISOR)
      ) {
        return {
          ...notification,
          meta: parsedMeta,
          url: `${userRole}/${tenantId}/data-reports/reports`,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.CALENDAR_MEETING ||
        notification.notificationType === IUSER_NOTIFICATION_TYPES.CALENDAR_MEETING_RESCHEDULED ||
        notification.notificationType === IUSER_NOTIFICATION_TYPES.CALENDAR_MEETING_CANCELLED
      ) {
        let url = `${userRole}/${tenantId}/calendar`
        if (parsedMeta?.resourceId) {
          url += `?details=${parsedMeta.resourceId}`
        }
        return {
          ...notification,
          meta: parsedMeta,
          url,
        }
      } else if (notification.notificationType === IUSER_NOTIFICATION_TYPES.CHAT) {
        const url = notification.senderId
          ? `${userRole}/${tenantId}/chat/${notification.senderId}`
          : `${userRole}/${tenantId}/chat`
        return {
          ...notification,
          meta: parsedMeta,
          url,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.SUGGESTED_GOAL_MESSAGE &&
        userRole === ROLES.V2
      ) {
        return {
          ...notification,
          meta: parsedMeta,
          url: `${userRole}/${tenantId}/goals`,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.ACCEPTED_GOAL_MESSAGE &&
        (userRole === ROLES.BSO_ADMIN || userRole === ROLES.BSO_ADVISOR)
      ) {
        return {
          ...notification,
          meta: parsedMeta,
          url: `${userRole}/${tenantId}/clients/${notification.senderId}/goals`,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.DECLINED_GOAL_MESSAGE &&
        (userRole === ROLES.BSO_ADMIN || userRole === ROLES.BSO_ADVISOR)
      ) {
        return {
          ...notification,
          meta: parsedMeta,
          url: `${userRole}/${tenantId}/clients/${notification.senderId}/goals`,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.SUGGESTED_PLAY_MESSAGE
      ) {
        let url = ''
        if (isAdvisor) {
          url = `${userRole}/${tenantId}/clients/${notification.senderId}/${
            parsedMeta?.data?.goalId || 'other-tasks'
          }/task?selectedTaskId=${parsedMeta?.data?.taskId}`
        } else {
          url = `${userRole}/${tenantId}/${
            parsedMeta?.data?.goalId || 'other-tasks'
          }/task?selectedTaskId=${parsedMeta?.data?.taskId}`
        }
        return {
          ...notification,
          meta: parsedMeta,
          url,
        }
      } else if (notification.notificationType === IUSER_NOTIFICATION_TYPES.ACCEPTED_PLAY_MESSAGE) {
        let url = ''
        if (isAdvisor) {
          url = `${userRole}/${tenantId}/clients/${notification.senderId}/${
            parsedMeta?.data?.goalId || 'other-tasks'
          }/task?selectedTaskId=${parsedMeta?.data?.taskId}`
        } else {
          url = `${userRole}/${tenantId}/${
            parsedMeta?.data?.goalId || 'other-tasks'
          }/task?selectedTaskId=${parsedMeta?.data?.taskId}`
        }
        return {
          ...notification,
          meta: parsedMeta,
          url,
        }
      } else if (notification.notificationType === IUSER_NOTIFICATION_TYPES.DECLINED_PLAY_MESSAGE) {
        let url = ''
        if (isAdvisor) {
          url = `${userRole}/${tenantId}/clients/${notification.senderId}/${
            parsedMeta?.data?.goalId || 'other-tasks'
          }/task?selectedTaskId=${parsedMeta?.data?.taskId}`
        } else {
          url = `${userRole}/${tenantId}/${
            parsedMeta?.data?.goalId || 'other-tasks'
          }/task?selectedTaskId=${parsedMeta?.data?.taskId}`
        }
        return {
          ...notification,
          meta: parsedMeta,
          url,
        }
      } else if (notification.notificationType === IUSER_NOTIFICATION_TYPES.PLAN_READY) {
        // The goal page, where the draft plan is reviewed (advisors: in the client's view)
        const data = parsedMeta?.data ?? {}
        const goalPath = data.goalId ? `goals/${data.goalId}/game-plan` : 'goals'
        return {
          ...notification,
          meta: parsedMeta,
          url:
            isAdvisor && data.businessId
              ? `${userRole}/${tenantId}/clients/${data.businessId}/${goalPath}`
              : `${userRole}/${tenantId}/${goalPath}`,
        }
      } else if (
        notification.notificationType === IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_ADDED ||
        notification.notificationType === IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_REPLY ||
        notification.notificationType === IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_MENTION ||
        notification.notificationType === IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_REPLY_MENTION
      ) {
        let url = `${userRole}/${tenantId}/${
          parsedMeta?.goalId || 'other-tasks'
        }/task?selectedTaskId=${parsedMeta?.taskId}`
        const isAdvisorOrAdmin = userRole === ROLES.BSO_ADVISOR || userRole === ROLES.BSO_ADMIN
        if (isAdvisorOrAdmin) {
          url = `${userRole}/${tenantId}/clients/${parsedMeta?.businessId}/${
            parsedMeta?.goalId || 'other-tasks'
          }/task?selectedTaskId=${parsedMeta?.taskId}`
        }
        return {
          ...notification,
          meta: {
            ...parsedMeta,
            playName: parsedMeta?.playName || '',
            goalSummary: parsedMeta?.goalSummary || '',
          },
          url,
        }
      } else
        return {
          ...notification,
          meta: parsedMeta,
        }
    })
  }
)
